export enum POSAMode {
  Online = "posa-online",
  Offline = "posa-offline"
}
